export const doggyComicImages = [
  `${process.env.REACT_APP_GCM_BUCKET_URL}/mythic-portal-v2/img/png/doggy-daycare/comic/cover.png`,
  `${process.env.REACT_APP_GCM_BUCKET_URL}/mythic-portal-v2/img/png/doggy-daycare/comic/comic1.png`,
  `${process.env.REACT_APP_GCM_BUCKET_URL}/mythic-portal-v2/img/png/doggy-daycare/comic/comic2.png`,
  `${process.env.REACT_APP_GCM_BUCKET_URL}/mythic-portal-v2/img/png/doggy-daycare/comic/comic3.png`
];
